import { PostsActions } from './actions'

const initialState = {
    posts: []
}

export const postsReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case PostsActions.FETCH_POSTS:
            return state
        case PostsActions.FETCH_POSTS_SUCCESS:
            return {
                ...state,
                posts: action.payload
            }
        default:
            return initialState
    }
}